import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import MessageAvatar
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageAvatar';
import MessageTime from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageTime';

const useStylesNoMargin = buildUseStyles('MessageLeftGutterNoMargin', ((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
  },
})));

const MessageLeftGutter = ({
  messageResource,
  showAvatar,
}) => {
  const classes = useStylesNoMargin();

  return (
    <div className={classes.root}>
      {showAvatar ? (
        <MessageAvatar messageResource={messageResource} />
      ) : (
        <MessageTime messageResource={messageResource} />
      )}
    </div>
  );
};

MessageLeftGutter.propTypes = {
  messageResource: PropTypes.object.isRequired,
  showAvatar: PropTypes.bool.isRequired,
};

export default MessageLeftGutter;
